export default "__VITE_ASSET__Cn7eHaZK__"